export default __webpack_public_path__ + "static/mini-verso-1-c4e1962488be898d8547da5a30a47e8c.jpg";